window.moment = require('moment/moment');
require('angular-cookies/angular-cookies');
require('js-data/dist/js-data');
require('js-data-angular/dist/js-data-angular');
require('angular-ui-router/release/angular-ui-router');
require('lodash/lodash');
require('angular-toastr/dist/angular-toastr.tpls');
require('angular-ui-bootstrap/dist/ui-bootstrap');
require('angular-ui-bootstrap/dist/ui-bootstrap-tpls.js');
require('angular-gridster/src/angular-gridster');
require('angular-google-chart/ng-google-chart');
require('angular-chart.js/angular-chart');
require('angular-translate/dist/angular-translate');
require('angular-translate-storage-local/angular-translate-storage-local');
require('angular-translate-storage-cookie/angular-translate-storage-cookie');
require('angular-translate-loader-url');
require('ui-select/dist/select');
require('d3/d3');
require('../modules/angular-spinner/angular-spinner');
require('spin/dist/spin');
require('flexmonster/flexmonster.full')
require('pivot-xml-report-converter/js/fm-converter')
require('./less/app.less');
window.XLSX = require('xlsx/xlsx.mjs');
import { renderReactRoot } from './react/Root';

// Dynamically require so Webpack finds them all.
const components = require.context('.', true, /^(?!.*\/assets\/).*\.js$/);
components.keys().forEach(components);


// Populate the AngularJS $templateCache
angular.module('app').run([
    '$templateCache',
    ($templateCache) => {
      const templates = require.context('../../', true, /^.*\.tpl\.html/);
      templates.keys().forEach((key) => {
        let templatePath = key.slice(2);
        if (templatePath.startsWith('Front/src/app/')) {
          templatePath = templatePath.slice('Front/src/app/'.length);
        } else if (templatePath.startsWith('Front/src/common/')) {
          templatePath = templatePath.slice('Front/src/common/'.length);
        }
        return $templateCache.put(templatePath, templates(key));
      });
    },
  ]);

  renderReactRoot(document.getElementById('react-root'));